import usePhotoDetailStore from "src/screens/(internal)/PhotoDetailModal/stores/usePhotoDetailStore";
import { PhotoItem } from "src/screens/(internal)/PhotoDetailModal/types";
import TagsOverlay from "./TagsOverlay";

const PhotoDetailTagDisplay = ({
	photo,
	photoScreenWidth,
	photoScreenHeight,
}: {
	photo: PhotoItem;
	photoScreenWidth: number;
	photoScreenHeight: number;
}) => {
	const asyncPhoto = usePhotoDetailStore((state) => state.asyncSettledPhoto);

	if (!asyncPhoto || photo.photoId !== asyncPhoto.photoId) return null;
	return (
		<TagsOverlay
			photo={asyncPhoto}
			photoScreenWidth={photoScreenWidth}
			photoScreenHeight={photoScreenHeight}
		/>
	);
};
export default PhotoDetailTagDisplay;
